export default __webpack_public_path__ + "media/customer-support.9c12bbefd6d2177212c9f6278c9297c9.svg";